const ComingSoon = () => (
  <div className="coming-soon-shell">
    <div className="coming-soon-grid" aria-hidden="true" />
    <div className="coming-soon-orbit coming-soon-orbit-one" aria-hidden="true" />
    <div className="coming-soon-orbit coming-soon-orbit-two" aria-hidden="true" />

    <header className="coming-soon-header">
      <div className="coming-soon-wordmark" aria-label="Wayfinder OS">
        <img src="/brand/wayfinder-mark-reversed.svg" alt="" />
        <span>
          Wayfinder <small>OS</small>
        </span>
      </div>
    </header>

    <main className="coming-soon-main">
      <section className="coming-soon-copy">
        <div className="coming-soon-status">
          <span aria-hidden="true" />
          Coming soon
        </div>

        <h1>
          Direction made <em>visible.</em>
          <br />
          Progress made <em>measurable.</em>
        </h1>

        <p>
          Wayfinder OS is preparing to launch—a clearer way to connect company
          direction, weekly execution, and people development in one operating
          system.
        </p>

        <div className="coming-soon-principles" aria-label="Wayfinder connects">
          <span>Strategy</span>
          <i aria-hidden="true" />
          <span>Execution</span>
          <i aria-hidden="true" />
          <span>People</span>
        </div>
      </section>

      <div className="coming-soon-visual" aria-hidden="true">
        <div className="coming-soon-preview-glow" />
        <div className="coming-soon-product">
          <div className="coming-soon-window-bar">
            <div><span /><span /><span /></div>
            <small>Wayfinder OS</small>
          </div>
          <div className="coming-soon-product-crop">
            <img src="/product/dashboard.jpg" alt="" />
          </div>
        </div>
        <div className="coming-soon-insight coming-soon-insight-top">
          <span>Company direction</span>
          <strong>Visible at a glance</strong>
        </div>
        <div className="coming-soon-insight coming-soon-insight-bottom">
          <span>Weekly execution</span>
          <strong>Attention stays clear</strong>
        </div>
        <div className="coming-soon-caption">A clearer operating view</div>
      </div>
    </main>

    <footer className="coming-soon-footer">
      <span>© {new Date().getFullYear()} Wayfinder OS</span>
      <span>Invitation only at launch</span>
    </footer>
  </div>
);

export default ComingSoon;
